var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcCancel = function SvgIcCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.887 2.66a.387.387 0 0 0-.548-.547L6 5.453l-3.34-3.34a.387.387 0 0 0-.547.548L5.453 6l-3.34 3.34a.387.387 0 0 0 .548.547L6 6.547l3.34 3.34a.387.387 0 1 0 .547-.548L6.547 6l3.34-3.34Z"
  })));
};
export default SvgIcCancel;